$(document).on("dropdown:shown", ".notifications", () => {
  Activity.track("notifications", "dropdown opened")
})

$(".notifications--i").on("click", (e) => {
  const value = e.target.href
  Activity.track("notifications", "link opened", value)
})
